<template>
  <PageHousing>
    <HProduct
      :name="product.name"
      :description="product.description"
      :image="product.image"
      :summary="product.summary"
    />
  </PageHousing>
</template>

<script>
import PageHousing from "@/components/PageHousing";
import HProduct from "@/components/HProduct";
import products from "@/data/products";

export default {
  components: {
    HProduct,
    PageHousing,
  },

  data() {
    return {
      product: products.filter((value) => value.page === "hobbot")[0],
    };
  },

  metaInfo: {
    title: `HobbsTech - Hobbot`,
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
};
</script>
